import React from 'react';
import { Button } from './ui/Button';
import { Download, Globe } from 'lucide-react';
export function TopBar() {
  return <div className="bg-[#2B0A3D] text-white py-2 px-4 sticky top-0 z-50 shadow-md" data-id="element-205">
      <div className="max-w-6xl mx-auto flex flex-col sm:flex-row justify-between items-center gap-2 text-xs sm:text-sm" data-id="element-206">
        <div className="flex items-center gap-4 text-center sm:text-left opacity-90" data-id="element-207">
          <span className="flex items-center gap-1" data-id="element-208">
            <Download className="w-3 h-3" data-id="element-209" /> Acceso inmediato
          </span>
          <span className="hidden sm:inline" data-id="element-210">•</span>
          <span className="hidden sm:inline" data-id="element-211">PDF descargable</span>
          <span className="hidden sm:inline" data-id="element-212">•</span>
          <span className="flex items-center gap-1" data-id="element-213">
            <Globe className="w-3 h-3" data-id="element-214" /> Funciona vivas donde vivas
          </span>
        </div>
        <Button href="https://pay.hotmart.com/X103396152N" variant="primary" size="sm" className="py-1 h-8 text-xs font-bold uppercase tracking-wider hidden sm:inline-flex" data-id="element-215">
          Comprar ahora
        </Button>
      </div>
    </div>;
}